import React from 'react';

const Link = props => (
  <a
    {...props}
    css={{
      color: '#2879fc',
      textDecoration: 'none',
      ':hover': {
        textDecoration: 'underline',
      },
    }}
  />
);

export default Link;



// WEBPACK FOOTER //
// ./src/components/Link.js